/*
 * Tiroir de panier — Hop Cadeau
 * - Message cadeau : enregistré dans l'attribut de panier « Message cadeau » (visible dans la commande).
 * - Code promo : appliqué au panier via /cart/update.js (calcul natif Shopify), le tiroir est rechargé ensuite.
 * Le contenu du tiroir est remplacé à chaque modification du panier : tout passe par des écouteurs délégués.
 * Le même script sert la page panier (/cart) : les zones marquées data-oh-live y sont rechargées.
 */
(function () {
  'use strict';
  if (window.ohCartDrawer) return;
  window.ohCartDrawer = true;

  var ATTR = 'Message cadeau';
  var giftTimer = 0;

  /* Ancienne version : code mémorisé dans le navigateur */
  try {
    window.localStorage.removeItem('oh_cart_promo');
  } catch (e) {}

  function updateUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/update.js';
  }

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart.js';
  }

  function postUpdate(body) {
    return fetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json();
    });
  }

  function saveGift(value) {
    var attributes = {};
    attributes[ATTR] = value;
    return postUpdate({ attributes: attributes }).catch(function () {});
  }

  /* Remplace le contenu du tiroir par la version fournie par l'API des sections */
  function refreshDrawer(sections) {
    var html = sections && sections['cart-drawer'];
    var target = document.querySelector('cart-drawer .drawer__inner');
    if (!html || !target) return;
    var source = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
    if (source) target.innerHTML = source.innerHTML;
  }

  function sectionsBody(body) {
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    return body;
  }

  /* ---------- Ajout au panier (Teeinblue : Shopify.onItemAdded) : mise à jour puis ouverture du tiroir ---------- */
  var addTimer = 0;
  function openDrawerAfterAdd(item) {
    window.clearTimeout(addTimer);
    addTimer = window.setTimeout(function () {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + '?sections=cart-drawer,cart-icon-bubble')
        .then(function (response) {
          return response.json();
        })
        .then(function (sections) {
          if (!sections || !sections['cart-drawer']) return;
          /* Comme le thème : le tiroir chargé avec un panier vide garde la marque is-empty, qui cache les produits */
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: item && item.id, sections: sections });
        })
        .catch(function () {});
    }, 50);
  }

  window.Shopify = window.Shopify || {};
  (function () {
    var previous = window.Shopify.onItemAdded;
    window.Shopify.onItemAdded = function (item) {
      if (typeof previous === 'function') {
        try {
          previous.apply(this, arguments);
        } catch (e) {}
      }
      openDrawerAfterAdd(item);
    };
  })();

  /* ---------- Page panier : rechargement des zones data-oh-live ---------- */
  function onPage() {
    return !!document.querySelector('[data-oh-cart-page]');
  }

  function refreshPage(keys) {
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    var ids = [];
    if (items && items.getAttribute('data-id')) ids.push(items.getAttribute('data-id'));
    if (footer && footer.getAttribute('data-id')) ids.push(footer.getAttribute('data-id'));
    if (!ids.length) return Promise.resolve();

    /* Pas d'en-tête Accept: sur /cart il ferait renvoyer le JSON du panier au lieu des sections */
    return fetch(window.location.pathname + '?sections=' + ids.join(','))
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        var docs = [];
        for (var i = 0; i < ids.length; i++) {
          if (sections[ids[i]]) docs.push(new DOMParser().parseFromString(sections[ids[i]], 'text/html'));
        }
        var zones = document.querySelectorAll('[data-oh-live]');
        for (var z = 0; z < zones.length; z++) {
          var key = zones[z].getAttribute('data-oh-live');
          if (keys && keys.indexOf(key) === -1) continue;
          for (var d = 0; d < docs.length; d++) {
            var source = docs[d].querySelector('[data-oh-live="' + key + '"]');
            if (source) {
              zones[z].innerHTML = source.innerHTML;
              break;
            }
          }
        }
      })
      .catch(function () {})
      .then(updateSticky);
  }

  /* Barre de paiement fixe (mobile) : masquée quand le vrai bouton est visible à l'écran */
  function updateSticky() {
    var btn = document.querySelector('#main-cart-footer #checkout');
    var off = false;
    if (btn && btn.getBoundingClientRect) {
      var r = btn.getBoundingClientRect();
      off = r.top < window.innerHeight && r.bottom > 0;
    }
    document.documentElement.classList.toggle('oh-sticky-off', off);
  }

  function resetPromoUi() {
    var roots = document.querySelectorAll('[data-oh-promo]');
    for (var i = 0; i < roots.length; i++) {
      var input = roots[i].querySelector('[data-oh-promo-input]');
      if (input) input.value = '';
      promoStatus(roots[i], '', '');
    }
  }

  /* ---------- Message cadeau ---------- */
  function giftRoot(el) {
    return el.closest ? el.closest('[data-oh-gift]') : null;
  }

  function updateCount(root) {
    var text = root.querySelector('[data-oh-gift-text]');
    var count = root.querySelector('[data-oh-gift-count]');
    if (text && count) count.textContent = String(text.value.length);
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target || !target.matches) return;

      if (target.matches('[data-oh-gift-toggle]')) {
        var root = giftRoot(target);
        if (!root) return;
        var panel = root.querySelector('[data-oh-gift-panel]');
        var text = root.querySelector('[data-oh-gift-text]');
        if (panel) panel.hidden = !target.checked;
        if (target.checked) {
          if (text) text.focus();
        } else if (text) {
          window.clearTimeout(giftTimer);
          text.value = '';
          updateCount(root);
          saveGift('');
        }
      } else if (target.matches('[data-oh-gift-text]')) {
        window.clearTimeout(giftTimer);
        saveGift(target.value.trim());
      }
    },
    true
  );

  document.addEventListener(
    'input',
    function (event) {
      var target = event.target;
      if (!target || !target.matches || !target.matches('[data-oh-gift-text]')) return;
      var root = giftRoot(target);
      if (root) updateCount(root);
      window.clearTimeout(giftTimer);
      giftTimer = window.setTimeout(function () {
        saveGift(target.value.trim());
      }, 700);
    },
    true
  );

  /* ---------- Code promo ---------- */
  function promoStatus(root, message, state) {
    var status = root.querySelector('[data-oh-promo-status]');
    if (!status) return;
    status.textContent = message;
    status.hidden = !message;
    if (state) status.setAttribute('data-state', state);
    else status.removeAttribute('data-state');
  }

  function appliedMessage(root, code) {
    var template = root.getAttribute('data-saved-text') || '{code}';
    return template.replace('{code}', code);
  }

  function togglePromoPanel(root, open) {
    var button = root.querySelector('[data-oh-promo-toggle]');
    var panel = root.querySelector('[data-oh-promo-panel]');
    if (!button || !panel) return;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
  }

  function busy(root, state) {
    var apply = root.querySelector('[data-oh-promo-apply]');
    if (apply) apply.disabled = state;
  }

  function codesOf(cart) {
    return (cart && cart.discount_codes) || [];
  }

  function applyPromo(root) {
    var input = root.querySelector('[data-oh-promo-input]');
    if (!input) return;
    var code = input.value.trim();
    if (!code) return;
    if (!/^[A-Za-z0-9_.\-]{2,40}$/.test(code)) {
      promoStatus(root, root.getAttribute('data-error-text') || 'Code invalide.', 'error');
      return;
    }
    busy(root, true);
    promoStatus(root, '', '');

    fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var previous = codesOf(cart)
          .filter(function (entry) {
            return entry.applicable;
          })
          .map(function (entry) {
            return entry.code;
          });

        return postUpdate(sectionsBody({ discount: code })).then(function (result) {
          var entry = codesOf(result).filter(function (item) {
            return String(item.code).toLowerCase() === code.toLowerCase();
          })[0];

          if (entry && entry.applicable) {
            refreshDrawer(result.sections);
            if (onPage()) {
              return refreshPage().then(function () {
                promoStatus(root, appliedMessage(root, String(entry.code || code).toUpperCase()), 'ok');
              });
            }
            return null;
          }
          /* Code refusé : on remet les codes précédents et on affiche l'erreur */
          return postUpdate({ discount: previous.join(',') }).then(function () {
            promoStatus(root, root.getAttribute('data-error-text') || 'Code invalide.', 'error');
          });
        });
      })
      .catch(function () {
        promoStatus(root, root.getAttribute('data-error-text') || 'Code invalide.', 'error');
      })
      .then(function () {
        busy(root, false);
      });
  }

  function removePromo() {
    postUpdate(sectionsBody({ discount: '' }))
      .then(function (result) {
        refreshDrawer(result.sections);
        if (onPage()) {
          return refreshPage().then(resetPromoUi);
        }
      })
      .catch(function () {});
  }

  /* Affiche l'état « code appliqué » après chaque rechargement du tiroir */
  function syncPromo() {
    var roots = document.querySelectorAll('[data-oh-promo]:not([data-oh-synced])');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      root.setAttribute('data-oh-synced', '');
      var code = root.getAttribute('data-applied');
      if (!code) continue;
      var input = root.querySelector('[data-oh-promo-input]');
      if (input) input.value = code.toUpperCase();
      promoStatus(root, appliedMessage(root, code.toUpperCase()), 'ok');
      togglePromoPanel(root, true);
    }
    /* Boutons de paiement express : à réinitialiser quand le tiroir est remplacé */
    var expressList = document.querySelectorAll('.oh-express:not([data-oh-init])');
    if (expressList.length) {
      for (var e = 0; e < expressList.length; e++) expressList[e].setAttribute('data-oh-init', '');
      try {
        if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
      } catch (err) {}
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var toggle = target.closest('[data-oh-promo-toggle]');
    if (toggle) {
      var root = toggle.closest('[data-oh-promo]');
      if (root) {
        togglePromoPanel(root, toggle.getAttribute('aria-expanded') !== 'true');
        if (toggle.getAttribute('aria-expanded') === 'true') {
          var input = root.querySelector('[data-oh-promo-input]');
          if (input) input.focus();
        }
      }
      return;
    }

    var apply = target.closest('[data-oh-promo-apply]');
    if (apply) {
      var box = apply.closest('[data-oh-promo]');
      if (box) applyPromo(box);
      return;
    }

    if (target.closest('[data-oh-promo-remove]')) removePromo();
  });

  document.addEventListener('keydown', function (event) {
    var target = event.target;
    if (event.key !== 'Enter' || !target || !target.matches || !target.matches('[data-oh-promo-input]')) return;
    event.preventDefault();
    var root = target.closest('[data-oh-promo]');
    if (root) applyPromo(root);
  });

  /* ---------- Initialisation + rechargements du tiroir ---------- */
  var syncTimer = 0;
  function scheduleSync() {
    if (syncTimer) return;
    syncTimer = window.setTimeout(function () {
      syncTimer = 0;
      syncPromo();
    }, 30);
  }

  function init() {
    syncPromo();
    if (onPage()) {
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      updateSticky();
    }
    /* Page panier : le bouton de paiement (prix) se met à jour après chaque changement de quantité */
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          if (onPage()) return refreshPage(['checkout']);
        });
      }
    } catch (err) {}
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(scheduleSync).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', scheduleSync);
})();
